import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=33ec799c&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=33ec799c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec799c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
